/**
 * Базовые кирпичи схемы формы Автокрафта: значение поля и поиск поля по ключу. Отдельно от
 * `autocraftPayload.ts` и `autocraftArrays.ts`, чтобы оба брали их отсюда, не импортируя друг
 * друга по кругу.
 */
import type { AutocraftDataField, AutocraftGeneratorSchema } from '../types/autocraft.js';

export type AutocraftFormValue = string | boolean | number | null;

export function getAutocraftField(
  schema: AutocraftGeneratorSchema,
  key: string,
): AutocraftDataField | null {
  if (key === '_order') {
    return null;
  }
  const value = schema.dataModel[key];
  return value && !Array.isArray(value) ? value : null;
}
